import React, { Fragment, useMemo } from 'react';
import { Card, Col, Icon, Row, Table, Tag } from 'antd';
import { currencyVND, dateToString } from '../../../../utils';
import moment from 'moment';

export default (props) => {

	const { detail } = props;
	const productList = detail?.products || [];

	const InfoRow = ({ label, value }) => (
		<Row style={{ marginBottom: 8 }}>
			<Col span={4}>{label}</Col>
			<Col span={20}>: {value || '---'}</Col>
		</Row>
	);

	const columns = [
		{
			title: 'STT',
			dataIndex: 'index',
			key: 'index',
			width: 60,
			render: (text, record, index) => index + 1
		},
		{
			title: 'Tên sản phẩm',
			dataIndex: 'productName',
			key: 'productName',
			width: 300,
			render: (text, record) => {
				return <Fragment><Row>
					<Col>
						<>{text}</>
					</Col>
				</Row>
				</Fragment>;
			}
		},
		// {
		// 	title: 'Phân Loại',
		// 	dataIndex: 'isNormal',
		// 	key: 'isNormal',
		// 	align: 'center',
		// 	width: 100,
		// 	render: (isNormal) => {
		// 		return isNormal ? <Tag style={{width: '110px'}} color="magenta">Sản phẩm thường</Tag> : <Tag style={{width: '110px'}} color="green">Serial/IMEI</Tag>;
		// 	}
		// },
		// {
		// 	title: 'Đơn vị',
		// 	dataIndex: 'unitName',
		// 	key: 'unitName',
		// 	align: 'center',
		// 	width: 150
		// },
		{
			title: 'Số lượng',
			width: 150,
			dataIndex: 'quantity',
			align: 'center'
		},
		{
			title: 'Đơn giá',
			dataIndex: 'unitPrice',
			width: 150,
			align: 'center',
			render: (unitPrice) => {
				return <>{`${currencyVND(unitPrice)}`}</>;
			}
		},
		{
			title: 'Chiết khấu',
			dataIndex: 'discount',
			key: 'discount',
			width: 150,
			align: 'center',
			render: (discount) => {
				return <>{`${currencyVND(discount)}`}</>;
			}
		},
		{
			title: 'Thành tiền',
			width: 150,
			align: 'center',
			render: (record) => {
				return <>{`${currencyVND((record.quantity * record.unitPrice) - (record.discount > 0 ? record.discount * record.quantity : 0))}`}</>;
			}
		},
		{
			title: 'Ngày tạo đơn',
			width: 150,
			align: 'center',
			render: () => dateToString(detail.createdDate)
		},
		{
			title: 'Ngày hết hạn bảo hành',
			width: 200,
			align: 'center',
			render: (record) => {
				return <>{dateToString(record?.warranty?.expiredDate, 'DD-MM-YYYY') || '---' }</>;
			}
		}
	];


	const expandedRowRender = (record) => {
		const imeiList = record?.imeis;
		return <Fragment>
			<div style={{ marginLeft: '60px' }}>
				<div className={'mt-20 mb-20'}>
					<i>Danh sách IMEI ({imeiList?.length || 0}): </i>{imeiList?.map((el) => <Tag color={'blue'} key={el}>
					{el}
				</Tag>)}
				</div>
			</div>
		</Fragment>;
	};

	const getExpandedRowKeys = () => {
		return productList.filter(el => el.imeis).map(el => el.productId);
	};

	const sum = useMemo(() => {
		let totalQuantity = 0;
		let sumPrice = 0;
		productList.forEach((el, idx) => {
			totalQuantity += el.quantity || 1;
			sumPrice += (el.totalPrice);
		});
		sumPrice = sumPrice - detail.discountAmount;
		return {
			totalQuantity,
			sumPrice
		};
	}, [productList]);

	const renderFooter = () => {
		let element;
		const s = sum;
		if (detail.invoiceRefundId) {
			element = <>
				<InfoRow label={<b>Giá trị mua hàng</b>} value={currencyVND(detail?.finalAmount) || '---'} />
				<InfoRow label={<b>Giá trị trả hàng <a
					onClick={() => window.open('/customer-refund/' + detail.invoiceRefundId)}>{detail.invoiceRefundCode}</a> </b>}
								 value={currencyVND(detail?.totalAmount + detail?.refundAmount) || '---'} />
				<InfoRow label={detail.refundAmount < 0 ? <b>Khách phải trả</b> : <b>Phải trả khách</b>}
								 value={<b
									 style={{ color: 'red' }}>{currencyVND(detail?.refundAmount < 0 ? detail?.refundAmount * -1 : detail?.refundAmount)}</b>} />
			</>;
		} else {
			element = <InfoRow label={detail?.refundAmount <= 0 ? 'Khách cần trả' : 'Cần trả khách'}
												 value={<b
													 style={{ color: 'red' }}>{productList.length > 0 ? currencyVND(s.sumPrice) : '---'} </b>} />;
		}
		return <Fragment>
			<InfoRow label={'Ghi chú'} value={detail?.note || '---'} />
			<InfoRow label={'Số lượng'} value={productList.length > 0 ? s.totalQuantity : '---'} />
			{/*<InfoRow label={'Chiết khấu'} value={productList.length > 0 ? currencyVND(detail.discountAmount) : '---'} />*/}
			{element}
		</Fragment>;

	};

	return (
		<Fragment>
			<Card title={<Fragment><Icon type="inbox" /> Thông tin sản phẩm</Fragment>} className={'mt-20'}>
				<Row gutter={12}>
					<Col>
						<Table
							rowKey={'productId'}
							dataSource={productList}
							columns={columns}
							rowClassName="editable-row"
							pagination={false}
							expandIconAsCell={false}
							expandedRowRender={expandedRowRender}
							expandedRowKeys={getExpandedRowKeys()}
							expandIcon={() => ''}
						/>
					</Col>
					<Col className={'mt-20'}>
						{renderFooter()}
					</Col>
				</Row>
			</Card>
		</Fragment>
	);
};
